"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

exports.default = stop;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

function stop() {
  var ts = this.TRANSITION_SCHEDULES;

  if (ts) {
    (0, _keys2.default)(ts).forEach(function (s) {
      ts[s].timer.stop();
    });
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/resonance/core/transition/stop.js
// module id = 333
// module chunks = 0